import { CircularProgress, Fade, CardContent } from "@mui/material"
import "./styles.scss"

function TradesLoading() {
  return <Fade in className="components_trades-panel-loading">
    <CardContent>
      <CircularProgress />
    </CardContent>
  </Fade>
}

export default TradesLoading
